import {Injectable} from '@angular/core';
import {ApiService} from '@core/api/api.service';
import {ClientPortalUser} from "@data/interefaces/client-portal.interfaces";
import {KpiSidebarItem} from "@shared/ag-kpi-sidebar/ag-kpi-sidebar.component.ds";
import {TableauLicenseRequestType} from "@data/enums/data.enums";
import {BatchProcessResult, ProductRespondentCompany} from "@data/interefaces/data.interfaces";
import {Util} from "@data/util/util";

@Injectable({
  providedIn: 'root'
})
export class ClientPortalService {
  private static REQUEST_SOURCE = "ARM Console";

  constructor(private _apiService: ApiService) {
  }

  public fetchAllUsers(): Promise<ClientPortalUser[]> {
    return this._apiService.makeGetServiceCall<ClientPortalUser[]>(`/v2/api/client-portal/users`);
  }

  public fetchUsersByLogins(logins: string[]): Promise<ClientPortalUser[]> {
    return this._apiService.makePostServiceCall<ClientPortalUser[]>(`/v2/api/client-portal/users/by-logins`, null, logins);
  }

  public tableauLicenseKpis(): Promise<KpiSidebarItem[]> {
    return this._apiService.makeGetServiceCall<KpiSidebarItem[]>(`/v2/api/client-portal/kpis`);
  }

  public sendTableauLicenseRequest(login: string, requestType: string): Promise<ClientPortalUser> {
    return this._apiService.makePutServiceCall<ClientPortalUser>(`/v2/api/client-portal/users/tableau-license`, null, {
      login: login,
      requestType: requestType,
      requestSource: ClientPortalService.REQUEST_SOURCE,
    });
  }

  public changeTableauLicenseType(login: string, isPermanent: boolean): Promise<ClientPortalUser> {
    return this._apiService.makePutServiceCall<ClientPortalUser>(`/v2/api/client-portal/users/tableau-license-type`, null, {
      login: login,
      isPermanent: isPermanent,
    });
  }

  public startTableauLicenseBatchProcess(users: ClientPortalUser[], processType: string) {
    let queryParams: string[] = [];
    Util.pushQueryParam("processType", processType, queryParams);
    Util.pushQueryParam("requestSource", ClientPortalService.REQUEST_SOURCE, queryParams);
    return this._apiService.makePutServiceCall<{ id: number }>(`/v2/api/client-portal/users/bulk-process/start`, queryParams.join('&'), users);
  }

  public getLatestTableauLicenseBatchProcess() {
    return this._apiService.makeGetServiceCall<BatchProcessResult>(`/v2/api/client-portal/users/bulk-process/latest`);
  }

}
